const isStringEmpty = (string) =>{
    return string === ''
}

export default isStringEmpty